module.exports = __webpack_public_path__ + "static/media/desktop_lg.dd1ed550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop_lg.svg
// module id = 3074
// module chunks = 0